import {
    mapMutations
} from "vuex";

export default {
    methods: {
        ...mapMutations([
            'SET_SNACKBAR_DATA'
        ]),
        displayInfo(messages) {
            messages.forEach(message => {
                setTimeout(() => {
                    this.SET_SNACKBAR_DATA({
                        type: "info",
                        text: message,
                        buttonRefresh: true,
                        duration: -1000
                    });
                });
            });
        }
    }
}